import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import categoryReducer from './slices/category';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import venueReducer from './slices/venue';
import inventoryReducer from './slices/inventory';
import orderReducer from './slices/order';
import tabReducer from './slices/tab';
import tabOrderReducer from './slices/tabOrder';
import userReducer from './slices/user';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const inventoryPersistConfig = {
  key: 'inventory',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const tabPersistConfig = {
  key: 'tab',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const venuePersistConfig = {
  key: 'venue',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['tenantVenue'],
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  category: categoryReducer,
  inventory: inventoryReducer,
  product: persistReducer(productPersistConfig, productReducer),
  tab: persistReducer(tabPersistConfig, tabReducer),
  tabOrder: tabOrderReducer,
  venue: persistReducer(venuePersistConfig, venueReducer),
  order: orderReducer,
  user: userReducer,
});

export { rootPersistConfig, rootReducer };
